import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageTitle } from "../../components/Layout";
import Card from "../../components/Card";
import EditorialCalendar from "../../components/EditorialCalendar";
import PostDetailModal from "../../components/PostDetailModal";
import * as Icons from "lucide-react";

// Les listes de comptes que l'agence identifie dans ses publications (décision du 27/10).
// L'entreprise les lit et peut en demander la modification ; elle ne les modifie pas elle-même, et
// ne voit jamais l'annuaire. La demande passe par « Demandes », qui sert à ce qui ne touche aucun
// projet (arbitrage du 01/10) : le volet s'ouvre pré-rempli, elle relit et envoie.
const MesListes = ({ listes }) => {
  if (!listes.length) return null;
  const demander = () => window.dispatchEvent(new CustomEvent("open-requests", { detail: { prefill: {
    type: "Autre",
    subject: "Comptes identifiés — demande de modification",
    description: "Bonjour,\n\nJe souhaite modifier les comptes identifiés dans mes publications :\n\n",
  } } }));
  return (
    <Card title="Comptes identifiés dans vos publications"
      action={<button onClick={demander} data-testid="comptes-demander"
        className="text-sm border border-marine text-marine rounded-sm px-3 py-1.5 hover:bg-marine hover:text-white transition-colors">Demander une modification</button>}>
      <p className="text-sm text-marine/80 mb-3">Les comptes que nous mentionnons pour vous, par groupe. Une publication peut en identifier un de plus, ponctuellement.</p>
      <div className="space-y-3" data-testid="client-mes-listes">
        {listes.map((l) => (
          <div key={l.id}>
            <div className="text-xs uppercase tracking-wider text-bordeaux mb-1">{l.name}</div>
            <div className="flex flex-wrap gap-2">
              {l.accounts.length === 0 && <span className="text-sm text-marine/80">Aucun compte pour le moment</span>}
              {l.accounts.map((c) => (
                <span key={c.id} title={`${c.handle} · ${c.network}`}
                  className="inline-flex max-w-full items-center px-2.5 py-1 rounded-full text-sm bg-sable border border-marine/20 text-marine">
                  <span className="truncate min-w-0">{c.handle}</span>
                  <span className="ml-1.5 shrink-0 text-xs text-marine/80">{c.network}</span>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default function ClientCalendar() {
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [listes, setListes] = useState([]);
  const [modal, setModal] = useState(null);

  const load = () => Promise.all([
    api.get("/client/calendar").then((r) => setPosts(r.data)),
    api.get("/client/tag-lists").then((r) => setListes(r.data)).catch(() => {}),
  ]);
  useEffect(() => { if (user.calendar_mode !== "external") load(); }, [user.calendar_mode]);

  if (user.calendar_mode === "external") {
    return (
      <div>
        <PageTitle overline="Communication" title="Calendrier éditorial" />
        <div className="bg-sable rounded-sm border border-marine/10 p-10 text-center max-w-lg mx-auto">
          <Icons.CalendarDays size={16} className="mx-auto text-marine mb-4" />
          <p className="text-sm text-marine/80 mb-5">Votre calendrier éditorial est géré sur une plateforme externe.</p>
          <a href={user.calendar_external_url} target="_blank" rel="noreferrer" data-testid="calendar-external-link"
            className="inline-flex items-center gap-2 bg-marine text-white rounded-sm px-5 py-3 text-sm hover:bg-marine-hover transition-colors">
            <Icons.ExternalLink size={16} /> {user.calendar_external_name || "Ouvrir le calendrier"}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageTitle overline="Communication" title="Calendrier éditorial" />
      <MesListes listes={listes} />
      <EditorialCalendar posts={posts} onPostClick={(p) => setModal(p)} />
      {modal && (
        <PostDetailModal mode="review" post={modal} onClose={() => setModal(null)} onSaved={load} />
      )}
    </div>
  );
}
